// A utility function as a better replacement for setTimeOut:
// keeps checking on a boolean condition passed as a 2nd arg
// and then only runs a func after the condition is found to be true
const RunUntil = (func, delay, condition) => {
    const interval = setInterval(() => {
        if (condition()) {
            clearInterval(interval);
        } else {
            func();
        }
    }, delay);
};
export default RunUntil;
